import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DialogModule } from '@zerops/fe/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { NgxStripeModule } from 'ngx-stripe';
import { ContentTitleModule } from '../content-title';
import { PriceModule } from '../price';
import { FeeItemModule } from '../fee-item';
import { ScrollableModule } from '../scrollable';
import { BulkPaymentFeesDialogContainer } from './bulk-payment-fees-dialog.container';
import { BulkPaymentPriceModule } from '../bulk-payment-price';
import { ProgressErrorModule } from '@app/common/progress-error';
import { PaymentFeesDialogEffect } from './bulk-payment-fees-dialog.effect';

@NgModule({
  declarations: [ BulkPaymentFeesDialogContainer ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ PaymentFeesDialogEffect ]),
    FlexLayoutModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    DialogModule,
    TranslateModule.forChild(),
    NgxQRCodeModule,
    NgxStripeModule,
    ContentTitleModule,
    PriceModule,
    FeeItemModule,
    ScrollableModule,
    BulkPaymentPriceModule,
    ProgressErrorModule
  ],
  exports: [ BulkPaymentFeesDialogContainer ]
})
export class BulkPaymentFeesDialogModule {
}
